<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <!--{{item.money}}-->
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="80%"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ ref }}</span>
            </Col>
          </Row>
        </div>
        <div
          style="text-align: center"
          v-for="(item, index) in Img"
          :key="index"
        >
          <img style="width: 80%" :src="item" alt="暂无图片" />
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "Resiliometer",
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      Img: "",
      photoArr1: [
        /*回弹仪*/
        {
          photoUrl: "../../../static/img/photo/photo_huitan.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_huitan.jpg",
          Img: ["../../../static/img/Buy/Resiliometer/res01.png"],
          ref: "智能回弹仪",
          money: "¥4500.00",
          classify: [
            {
              type: "",
              money: "¥4500.00",
              img: "../../../static/img/photo-da/photo_huitan.jpg",
            },
          ],
          title: "智能测量工具",
          belong: "智能回弹仪",
          path: "/home/Buy/Resiliometer",
        },
        /*智能靠尺*/
        {
          photoUrl: "../../../static/img/photo/photo_rule.png",
          photoUrl1: "../../../static/img/photo-da/photo_rule.png",
          Img: ["../../../static/img/Buy/Rule/rule01.png"],
          ref: "数字蓝牙智能靠尺",
          money: "￥30.00-￥680.00",
          classify: [
            {
              type: "仅软件",
              money: "￥30.00",
              img: "../../../static/img/photo-da/photo_rule.png",
            },
            {
              type: "仅数字蓝牙模块",
              money: "￥560.00",
              img: "../../../static/img/photo-da/photo_rule.png",
            },
            {
              type: "全套(靠尺+模块+软件)",
              money: "¥680.00",
              img: "../../../static/img/photo-da/photo_rule.png",
            },
          ],
          title: "智能测量工具",
          belong: "智能靠尺",
          path: "/home/Buy/Resiliometer",
        },
        /*测距仪*/
        {
          photoUrl: "../../../static/img/photo/photo_ceju02.png",
          photoUrl1: "../../../static/img/photo-da/photo_ceju02.png",
          Img: ["../../../static/img/Buy/Diastimeter/dis02.jpg"],
          ref: "测距仪智能激光红外线尺装修房屋量高面积携式迷你毫米精度",
          money: "￥120.00",
          classify: [
            {
              type: "便携式迷你款测距仪 红色",
              money: "￥120.00",
              img: "../../../static/img/photo/photo_ceju02.png",
            },
          ],
          title: "智能测量工具",
          belong: "智能测距仪",
          path: "/home/Buy/Resiliometer",
        },
        /*游标卡尺*/
        {
          photoUrl:
            "../../../static/img/Buy/VernierCaliper/VernierCaliper01.png",
          photoUrl1:
            "../../../static/img/Buy/VernierCaliper/VernierCaliper01.png",
          Img: [
            "../../../static/img/Buy/VernierCaliper/VernierCaliper02.jpg",
            "../../../static/img/Buy/VernierCaliper/VernierCaliper03.jpg",
            "../../../static/img/Buy/VernierCaliper/VernierCaliper04.jpg",
          ],
          ref: "游标卡尺",
          money: "¥900.00",
          classify: [
            {
              type: "",
              money: "¥3900.00",
              img: "../../../static/img/Buy/VernierCaliper/VernierCaliper01.png",
            },
          ],
          title: "智能测量工具",
          belong: "游标卡尺",
          path: "/home/Buy/Resiliometer",
        },
      ],
    };
  },

  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
      this.Img = item.Img;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #f7f7f7;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/Resiliometer.vue